import { eTipoPermissao } from '@/enums/ePermissoes';

export default [
  {
    description: 'Função Escola',
    path: '/pessoal/pesfuncaoescola',
    name: 'pesfuncaoescola',
    component: () => import('@/views/pessoal/pesfuncaoescola/Index.vue'),
    meta: {
      permissions: [eTipoPermissao.FUNCAOESCOLANOVO_MENU_1400400299],
    },
    goesToMenu: true,
  },
]
